var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplateBoxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path847",
    d: "m 560,288 h -80 v 88 c 0,4.4 -3.6,8 -8,8 h -48 c -4.4,0 -8,-3.6 -8,-8 v -88 h -80 c -8.8,0 -16,7.2 -16,16 v 192 c 0,8.8 7.2,16 16,16 h 224 c 8.8,0 16,-7.2 16,-16 V 304 c 0,-8.8 -7.2,-16 -16,-16 z",
    style: {
      fill: "#9d3c88",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path845",
    d: "m 176,224 h 224 c 8.8,0 16,-7.2 16,-16 V 16 C 416,7.2 408.8,0 400,0 h -80 v 88 c 0,4.4 -3.6,8 -8,8 h -48 c -4.4,0 -8,-3.6 -8,-8 V 0 h -80 c -8.8,0 -16,7.2 -16,16 v 192 c 0,8.8 7.2,16 16,16 z",
    style: {
      fill: "#1780bb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    d: "m 240,288 h -80 v 88 c 0,4.4 -3.6,8 -8,8 h -48 c -4.4,0 -8,-3.6 -8,-8 V 288 H 16 c -8.8,0 -16,7.2 -16,16 v 192 c 0,8.8 7.2,16 16,16 h 224 c 8.8,0 16,-7.2 16,-16 V 304 c 0,-8.8 -7.2,-16 -16,-16 z",
    style: {
      fill: "#38a91e",
      fillOpacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateBoxes);
export default __webpack_public_path__ + "static/media/TemplateBoxes.a7126b89.svg";
export { ForwardRef as ReactComponent };